{
    "ChangeMenuTitle": "Rapport sur les changements",
    "UnknownReport": "[Rapport inconnu]",
    "NoSuitableReportsAvailable": "Aucun rapport approprié n'est disponible.",
    "DashboardChangeFolderEmpty": "Tous les rapports de ce dossier ont déjà été utilisés dans ce tableau de bord...",
    "DashboardList_SectionHeader": "Liste",
    "DashboardList_Add": "Ajouter",
    "DashboardList_AddMenuTitle": "Ajouter et supprimer",
    "DashboardList_MoveUp": "Avancez",
    "DashboardList_MoveDown": "Descendre",
    "DashboardList_Remove": "Retirer",
    "DashboardList_RemoveAll": "Supprimer tout",
    "DashboardList_RemoveAllConfirmMessage": "Êtes-vous sûr de vouloir supprimer tous les rapports ?",
    "NAME": "DashboardList"
}